export enum Role {
    Admin = 'ROLE_ADMIN',
    ServiceAdmin = 'ROLE_SERVICE_ADMIN',
    Employee = 'ROLE_EMPLOYEE',
    User = 'ROLE_USER',
}
